// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.scl--notif-sidebar-backdrop {
  position: fixed;
  inset: 0;
  width: 100vw;
  height: 100vh;
  z-index: 1050; /* above page content, below popup overlay (1000 is popup) */
  background: rgba(0, 0, 0, 0.4);
  opacity: 0;
  pointer-events: none;
  transition: opacity 220ms ease;
}

.scl--notif-sidebar-backdrop.active {
  opacity: 1;
  pointer-events: auto;
}

.scl--notif-sidebar-panel {
  position: fixed;
  top: 0;
  right: 0;
  width: 419px;
  height: 100vh;
  z-index: 1051; /* above backdrop */
  background: #ffffff;
  transform: translateX(100%);
  transition: transform 280ms cubic-bezier(0.22, 1, 0.36, 1);
  display: flex;
  flex-direction: column;
}

.scl--notif-sidebar-panel.active {
  transform:  translateX(0);
  /* ✅ visibility becomes visible instantly on open (no delay) */
  visibility: visible;
  transition: transform 0.28s cubic-bezier(0.4, 0, 0.2, 1),
              visibility 0s linear 0s;
}



/* ── Content (scrollable) ──────────────────────────────────── */
.scl--notif-sidebar-content {
  flex:       1;
  overflow-y: auto;
  overflow-x: hidden;
}

.scl--notif-sidebar-content::-webkit-scrollbar {
  width: 4px;
}

.scl--notif-sidebar-content::-webkit-scrollbar-track {
  background: transparent;
}

.scl--notif-sidebar-content::-webkit-scrollbar-thumb {
  background:    #E5E7EB;
  border-radius: 999px;
}

.scl--notif-sidebar-content::-webkit-scrollbar-thumb:hover {
  background: #D1D5DB;
}`, "",{"version":3,"sources":["webpack://./src/context-controller-mod/context-serv/global-provider/right-sidebar-context/css/notificationSidebarContext.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,aAAa,EAAE,4DAA4D;EAC3E,8BAA8B;EAC9B,UAAU;EACV,oBAAoB;EACpB,8BAA8B;AAChC;;AAEA;EACE,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,aAAa,EAAE,mBAAmB;EAClC,mBAAmB;EACnB,2BAA2B;EAC3B,0DAA0D;EAC1D,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,8DAA8D;EAC9D,mBAAmB;EACnB;qCACmC;AACrC;;;;AAIA,iEAAiE;AACjE;EACE,aAAa;EACb,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":[".scl--notif-sidebar-backdrop {\n  position: fixed;\n  inset: 0;\n  width: 100vw;\n  height: 100vh;\n  z-index: 1050; /* above page content, below popup overlay (1000 is popup) */\n  background: rgba(0, 0, 0, 0.4);\n  opacity: 0;\n  pointer-events: none;\n  transition: opacity 220ms ease;\n}\n\n.scl--notif-sidebar-backdrop.active {\n  opacity: 1;\n  pointer-events: auto;\n}\n\n.scl--notif-sidebar-panel {\n  position: fixed;\n  top: 0;\n  right: 0;\n  width: 419px;\n  height: 100vh;\n  z-index: 1051; /* above backdrop */\n  background: #ffffff;\n  transform: translateX(100%);\n  transition: transform 280ms cubic-bezier(0.22, 1, 0.36, 1);\n  display: flex;\n  flex-direction: column;\n}\n\n.scl--notif-sidebar-panel.active {\n  transform:  translateX(0);\n  /* ✅ visibility becomes visible instantly on open (no delay) */\n  visibility: visible;\n  transition: transform 0.28s cubic-bezier(0.4, 0, 0.2, 1),\n              visibility 0s linear 0s;\n}\n\n\n\n/* ── Content (scrollable) ──────────────────────────────────── */\n.scl--notif-sidebar-content {\n  flex:       1;\n  overflow-y: auto;\n  overflow-x: hidden;\n}\n\n.scl--notif-sidebar-content::-webkit-scrollbar {\n  width: 4px;\n}\n\n.scl--notif-sidebar-content::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.scl--notif-sidebar-content::-webkit-scrollbar-thumb {\n  background:    #E5E7EB;\n  border-radius: 999px;\n}\n\n.scl--notif-sidebar-content::-webkit-scrollbar-thumb:hover {\n  background: #D1D5DB;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
